// extracted by mini-css-extract-plugin
export default {"container":"SavedLocationNamingCard_container__Tp-P0","message":"SavedLocationNamingCard_message__yhxW8"};